import BaseServices from './../../helpers/BaseServices';
import { API_VENDAS, API_CADIMO5 } from "./constants";
import RequestUtils from '../../services/requestUtils';

export default class Services extends BaseServices {
    constructor() {
        super(API_VENDAS, API_CADIMO5);
    };

    getDetalhesImovel = (modalidade, codigo) => {
        let url = RequestUtils.uriResolver(modalidade.toLowerCase());
        let method = RequestUtils.methodResolver('detalhes', modalidade.toLowerCase());

        url += `${method}${codigo}`;

        console.log("URL DETALHES: ", url);

        return fetch(`${url}`, BaseServices._getRequestInfo(modalidade.toLowerCase()))
            .then(response => {
                if (!response.ok) {
                    throw response.json();
                }
                return response.json();
            });
    }

    solicitarInformacoesImovel = (dados) => {
        return fetch(`${API_VENDAS}/email/solicitarInformacoesImovel`, BaseServices._getRequestInfo('POST', `${JSON.stringify(dados)}`))    
          .then(response => {
            if (!response.ok) {
              throw response.json();          
            }
            return response.json();
          });
    }
    

}